import React, { useState } from 'react';
import axios from 'axios';
import './Forgot.css';
import coderwinglogo from "../Image/coderwing-logo.png";
const apiUrl = process.env.REACT_APP_API_BASE_URL;

const Forgot = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    
    try {
      const response = await axios.post(`${apiUrl}/api/auth/forget-password`, { email });
      setMessage(response.data.msg);
    } catch (err) {
      setError(err.response?.data?.msg || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recovery-container">
      <div className="recovery-left">
        <div className="logo">
          <img src={coderwinglogo} alt="Coderwing Logo" className="logo-text" />
        </div>
        
        <div className="sign-in-btn-container">
          <button className="sign-in-btn">Sign In</button>
        </div>
        
        <div className="recovery-form-container">
          <h1 className="recovery-title">Forgot Password</h1>
          <p className="recovery-description">
            Enter your email for the verification process. We will send a reset link to your email.
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="input-container">
              <input 
                type="email" 
                placeholder="Enter your email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <button type="submit" className="recover-btn" disabled={loading}>
              {loading ? 'Sending...' : 'Recover your password'}
            </button>
          </form>
          
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}
        </div>
      </div>
      
      <div className="recovery-right">
        
      </div>
    </div>
  );
};

export default Forgot;
